import { useQuery } from '@tanstack/react-query'

import { requestStatmentAccount, GetPartnerStatement } from '../../api/statementAccount'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetPartnerStatementAccount(request:requestStatmentAccount) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_ACCOUNT_STATEMENT_PARTNER, request.externalId ?? '', request.loyaltyPlanId ?? ''],
      queryFn: () => GetPartnerStatement(request),
      enabled: !!request.externalId && typeof request.loyaltyPlanId === 'number',
   })
}

export { useGetPartnerStatementAccount }
export default useGetPartnerStatementAccount